export default "__VITE_ASSET__DWNytVg9__"